var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.modal)?_c(_vm.modal.component,{tag:"component",attrs:{"value":_vm.modal.value}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }